module.exports = __webpack_public_path__ + "static/media/dice-d4.fff2a4ef.svg";